import defaultColor from "@/components/color";

const dataText = JSON.stringify([
    {
        group:'广州机房',
        data:[
            {name:'Mon',value:120},
            {name:'Tue',value:200},
            {name:'Wed',value:150},
            {name:'Thu',value:80},
            {name:'Fri',value:70},
            {name:'Sat',value:110},
        ]
    },
    {
        group:'深圳机房',
        data:[
            {name:'Mon',value:100},
            {name:'Tue',value:120},
            {name:'Wed',value:70},
            {name:'Thu',value:60},
            {name:'Fri',value:170},
            {name:'Sat',value:90},
        ]
    }
])

export default {
    attribute:{
        color:defaultColor,
        xAxis: {
            name: ' ',
            type: 'category',
            axisLabel:{
                color: '#6aa9e4',
                fontSize:13
            },
            axisLine:{
                lineStyle: {
                    color: '#02438e'
                }
            },
            axisTick:{//y轴刻度线
                show: false
            },
            splitLine: {//网格线    
                show:false,
                lineStyle:{
                    color: '#6aa9e4'
                }   
            }
        },
        yAxis: {
            name: ' ',
            type: 'value',
            axisLabel:{
                textStyle:{
                    color: '#6aa9e4',
                    fontSize: 13
                }
            },
            axisLine:{
                show: true,
                lineStyle:{
                    color: '#02438e'
                }
            },
            axisTick:{//y轴刻度线
                show: false
            },
            splitLine: {//网格线
                show:true,
                lineStyle:{
                    color: '#14477e'
                }
            }
        },
        title: {
            text: '',
            left: 'center',
            top: 'top',
            textStyle:{
                fontSize:18,
                color: '#ccc'
            },
            subtextStyle: { fontSize: 12, color: '#aaa' }
        },
        boxDepth: 20,
        series:{
            symbolSize:6,
            lineStyle:{
                width: 3
            },
            label: {
                show: false , //数值
                color: '#ddd',
                fontSize: 13
            }
        },
        tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        cptTableData: [{ "name": "分组", "value": "", "namekey": "group" },
        { "name": "维度", "value": "", "namekey": "name" },
        { "name": "指标", "value": "", "namekey": "value" }]
    },
    cptDataForm:{dataText: dataText,dataSource: 1, pollTime: 0},
}
